const actions = {
  SET_STATE: 'customSpinner/SET_STATE',
  setloader: 'customSpinner/setloader',
  removeLoader: 'customSpinner/removeLoader'
}

export default actions
